import { createContext, useContext } from 'react';
import { TSortBy } from './components/HotEventPanel/types';

export interface HotEventContextValue {
  gameInfo: any;
  wholeGameInfo: any;
  filter: any;
  /** 同步日期到 Redux → FilterCommon UI（编程式修改日期时调用） */
  onFilterDateSync: (dateRange: { start_time: string; end_time: string }) => void;
  sentimentValue: string;
  channelType: string;
  sortBy: TSortBy;
  onSortByChange: (value: TSortBy) => void;
  /** Cluster 分类筛选值，'all' 表示全部 */
  clusterCategoriesValue: string;
}

const HotEventContext = createContext<HotEventContextValue | null>(null);

export const HotEventProvider = HotEventContext.Provider;

export function useHotEventContext(): HotEventContextValue {
  const ctx = useContext(HotEventContext);
  if (!ctx) {
    throw new Error('useHotEventContext must be used within HotEventProvider');
  }
  return ctx;
}
